import * as Logger from '../libs/wa-logger.ts';
const $ = require('jquery');

export const initialize = function() {
    if ($('body.archive').length === 0) {
        return;
    }

    Logger.log('Archive Menu Accordion initializing');

    $('.filter-widget.archive-filter-accordion .filter-header').on('click', function() {
        const $header = $(this);
        const $items = $header.next('.filter-items');

        // Toggle current one
        $header.toggleClass('open');
        $items.toggleClass('open');

        // Optional: Close others
        $('.filter-widget.archive-filter-accordion .filter-header').not($header).removeClass('open');
        $('.filter-widget.archive-filter-accordion .filter-items').not($items).removeClass('open');
    });
};
